import React from "react";
import Footer from "../../Home/Footer";
import Header from "../../Home/Header";
import DecentralizedExHero from "./DecentralizedExHero";
import WhatIsDedEx from "./WhatIsDedEx";
import NonCustodial from "./NonCustodial";
import CustomDEDev from "./CustomDEDev";
import AdvancedTOptions from "./AdvancedTOptions";
import EnterDeFi from "./EnterDeFi";
import LowerMaintenance from "./LowerMaintenance";

function DecentralizedExchange() {
  return (
    <div>
      <Header />
      <DecentralizedExHero />
      <WhatIsDedEx />
      <CustomDEDev />
      <AdvancedTOptions />
      <EnterDeFi />
      <NonCustodial />
      {/* <LowerMaintenance /> */}
      <Footer />
    </div>
  );
}

export default DecentralizedExchange;
